import axios from "axios";
import CacheStorageService from "./cacheStorage.service";
class CompanyService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl;
    }

    /**
 * @author Edgar Escobedo
 * @description Get companys from a clientId
 * @date 20-07-2020
 * @param {String} token
 * @returns {Object}
 * @memberof CompanyService
 */
    async getCompanys(token) {
        let response = await axios.get(
            `${this.apiUrl}/client-company`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response;
    }

    /**
   * @author Adriana Fernandez
   * @description Get the companies that a user has access to
   * @date 02-10-2023
   * @param {String} token
   * @returns {Object}
   * @memberof CompanyService
   */
    async getUsersCompanies(token) {
        const cache = new CacheStorageService();
        cache.deleteUrlFromCache('/categories')

        let response = await axios.get(
            `${this.apiUrl}/companies`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    }
}

export { CompanyService as default };